"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateMuscleSplit = void 0;
const intersection_1 = __importDefault(require("lodash/intersection"));
const calculateMuscleSplit = (workoutsOrRoutines) => {
    const coreMuscles = ['abdominals'];
    const shoulderMuscles = ['shoulders'];
    const armMuscles = ['biceps', 'triceps', 'forearms'];
    const legMuscles = [
        'quadriceps',
        'hamstrings',
        'glutes',
        'calves',
        'abductors',
        'adductors',
    ];
    const backMuscles = [
        'lower_back',
        'upper_back',
        'lats',
        'traps',
    ];
    const chestMuscles = ['chest'];
    let core = 0;
    let shoulders = 0;
    let arms = 0;
    let legs = 0;
    let back = 0;
    let chest = 0;
    const muscleGroupValueIncrement = (e, mg) => {
        let increment = 0;
        if (mg.includes(e.muscle_group)) {
            increment += e.sets.length;
        }
        else if ((0, intersection_1.default)(mg, e.other_muscles).length) {
            increment += e.sets.length / 2;
        }
        else if (e.muscle_group === 'full_body') {
            increment += e.sets.length / 6;
        }
        return increment;
    };
    for (const workout of workoutsOrRoutines) {
        for (const exercise of workout.exercises) {
            core += muscleGroupValueIncrement(exercise, coreMuscles);
            shoulders += muscleGroupValueIncrement(exercise, shoulderMuscles);
            arms += muscleGroupValueIncrement(exercise, armMuscles);
            legs += muscleGroupValueIncrement(exercise, legMuscles);
            back += muscleGroupValueIncrement(exercise, backMuscles);
            chest += muscleGroupValueIncrement(exercise, chestMuscles);
        }
    }
    return {
        core,
        shoulders,
        arms,
        legs,
        back,
        chest,
    };
};
exports.calculateMuscleSplit = calculateMuscleSplit;
